import { useEffect, useState } from 'react';

import axios from 'axios';
import { URLS } from '../config';
import { ConfigTypes } from '../types';

export const useGetConfiguration = () => {
  const [getConfiguration, setConfiguration] = useState<ConfigTypes>({});
  const [dishesLoading, setDishesLoading] = useState<boolean>(false);

  const getDishes = async () => {
    setDishesLoading(true);

    try {

      const response = await axios.get(URLS.GET_CONFIGS);
      setConfiguration(response.data);
      localStorage.setItem("menuConfiguration",JSON.stringify(response.data.config))
    } catch (error) {
      //console.error(error);
    } finally {
      setDishesLoading(false);
    }
  };

  useEffect(() => {
    getDishes();
  }, []);

  return {dishesLoading, getConfiguration};
};
